import type { RouteHandle } from '@app/routes/handle';
import { useIsPhone } from '@shared/hooks/useIsPhone';
import { useMatches } from 'react-router-dom';

export interface PhoneGate {
  /** The page on screen is not built for phones, and this is one. */
  desktopOnly: boolean;
  /** The page's title key, to name it on the desktop-only screen. */
  titleKey: string | undefined;
}

/**
 * On a phone only the pages built for it render (`mobileReady` on their route's handle); every
 * other page of the shell shows the desktop-only screen instead. The deepest matched route is the
 * page on screen.
 */
export function usePhoneGate(): PhoneGate {
  const isPhone = useIsPhone();
  const matches = useMatches();
  const handle = matches[matches.length - 1]?.handle as RouteHandle | undefined;
  return {
    desktopOnly: isPhone && handle?.mobileReady !== true,
    titleKey: handle?.titleKey,
  };
}
